module.exports = __webpack_public_path__ + "img/9.2.TN.af13ba04.png";